import { render, staticRenderFns } from "./Detailparent.vue?vue&type=template&id=4645522a&scoped=true&"
import script from "./Detailparent.vue?vue&type=script&lang=js&"
export * from "./Detailparent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4645522a",
  null
  
)

export default component.exports